import { useToast } from '../../context/ToastContext';

const TYPE_CONFIG = {
  success: {
    border: 'border-l-emerald-500',
    icon: (
      <svg className="w-4 h-4 text-emerald-500 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
      </svg>
    ),
  },
  error: {
    border: 'border-l-red-500',
    icon: (
      <svg className="w-4 h-4 text-red-500 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
      </svg>
    ),
  },
  info: {
    border: 'border-l-blue-500',
    icon: (
      <svg className="w-4 h-4 text-blue-500 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
      </svg>
    ),
  },
};

function ToastItem({ toast, onDismiss }) {
  const config = TYPE_CONFIG[toast.type] || TYPE_CONFIG.success;

  return (
    <div
      className={`wm-toast-in wm-glass pointer-events-auto flex items-start gap-3 min-w-[220px] max-w-[340px] px-3 py-2.5 rounded-xl border-l-[3px] ${config.border}`}
      style={{ background: 'var(--wm-glass-bg)', border: '1px solid var(--wm-glass-border)', boxShadow: '0 20px 60px rgba(0,0,0,0.22), inset 0 1px 0 var(--wm-glass-specular)' }}
    >
      {config.icon}
      <p className="flex-1 text-[var(--wm-text-body)] font-medium text-[#0F1923] dark:text-[#F8FAFE] leading-snug">
        {toast.message}
      </p>
      <button
        onClick={onDismiss}
        className="flex-shrink-0 text-[#7D93AE] hover:text-[#0F1923] dark:hover:text-[#F8FAFE] transition-colors mt-0.5"
        aria-label="Dismiss"
      >
        <svg className="w-3.5 h-3.5" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
      </button>
    </div>
  );
}

export default function ToastStack() {
  const { toasts, dismiss } = useToast();
  if (!toasts.length) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="fixed bottom-4 right-4 z-[9999] flex flex-col gap-2 items-end pointer-events-none"
    >
      {toasts.map(t => (
        <ToastItem key={t.id} toast={t} onDismiss={() => dismiss(t.id)} />
      ))}
    </div>
  );
}
